<template>
  <div class="home-page">
    <div class="home-page-main">
      <p class="home-page-title">水晶</p>
      <p class="home-page-sub-title">仓配数字化运控系统</p>
      <p class="home-page-content">水晶，为仓储公司提供数字化仓配生产、运营及成本控制的整体管理解决方案。通过
建立仓配项目预算与核算模型、生产大数据采集与分析等技术手段，实现仓库服务质
量实时跟踪、单项目及整仓利润精细核算、服务账单自动生成，生产资源合理调度，
最终有效控制各项成本支出，提高生产运营效率，增强公司的盈利能力和服务水平。</p>
    </div>
  </div>
</template>

<script>
import { deleteToken, delDBUserRealName, delTags, getSetFlag } from "@/common/js/storage";
export default {

  data() {
    return {
    }
  },

  created() {
    if (!getSetFlag()) this.backLogin()
  },

  methods: {
    backLogin() {
      this.$confirm("无任何仓库权限，请联系系统管理员授权", "暂无权限", {
        type: 'warning',
        center: true,
        showCancelButton: false,
        confirmButtonText: "返回登录",
        confirmButtonClass: 'btn-blue',
      }).then(() => {
        deleteToken();
        delTags();
        delDBUserRealName();
        this.$router.push("/login");
      });
    }
  }
}
</script>

<style lang='scss'>
.home-page {
  flex: 1;
  background: url('../../../../assets/images/home/bg-home.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  border-radius: 4px;
  .home-page-main {
    padding: 100px 0px 0px 362px;
    .home-page-title {
      font-size: 60px;
      font-family: 'PingFang SC-Medium, PingFang SC';
      font-weight: 500;
      color: $baseGrey;
    }
    .home-page-sub-title {
      font-size: 28px;
      font-family: 'PingFang SC-Medium, PingFang SC';
      font-weight: 500;
      color: $baseGrey;
      margin: 20px 0px 40px 0px;
    }
    .home-page-content {
      width: 592px;
      font-size: 16px;
      font-family: 'PingFang SC-Medium, PingFang SC';
      font-weight: 500;
      color: $homePage;
      line-height: 28px;
    }
  }
}
.el-message-box--center {
  .el-message-box__header {
    .el-message-box__title {
      @include flex-start;
      .el-message-box__status.el-icon-warning {
        font-size: 18px !important;
        margin-top: 3px
      }
    }
  }
  .el-message-box__content {
    @include flex-start;
  }
  .el-message-box__btns {
    @include flex-end;
    .el-button.btn-blue:hover,
    .el-button.btn-blue {
      background: $baseThreeSnow;
      color: $baseGrey;
      border: 0px;
      font-size: 14px;
      font-family: 'PingFang SC-Regular, PingFang SC';
    }
  }
}
</style>
